import { ApplicationStatusEnum, UniversityExistenceEnum } from '../tutor/res';
import type ResType from '../type';
import { UserUniversityApplicationType } from './req';

export enum ApplicationTypeEnum {
  NEW = 'NEW',
  MODIFY = 'MODIFY',
}

export type GetBadgesResType = ResType<
  Array<{
    id: string;
    name: string;
    imageUrl: string;
    isUniversity: boolean;
  }>
>;

export type PostBadgesResType = ResType<{}>;
export type PatchBadgesResType = ResType<{}>;
export type DeleteBadgesResType = ResType<{}>;

export type PostBadgeApplicationResType = ResType<{}>;

export type GetBadgeApplicationStatusResType = ResType<{
  status: ApplicationStatusEnum;
  rejectReason: string;
  type: ApplicationTypeEnum;
}>;

export type BadgeUniversityApplicationType = {
  id: string;
  status: ApplicationStatusEnum;
  rejectReason: string;
  type: ApplicationTypeEnum;
  universities: UserUniversityApplicationType[];
  user: UserType;
  existencies: UniversityExistenceEnum[];
  createAt: string;
  updatedAt: string;
};
export type GetBadgeUniversityApplicationResType = ResType<{
  totalCount: number;
  applications: BadgeUniversityApplicationType[];
}>;

export type PatchApplicationApprovalResType = ResType<{}>;
